import React from "react";

export default function BankAccountDetail(){
    return(
        <>
        BankAccountDetail
        </>
    )
}